import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import { makeFavoritesPage } from '@/main/factories/pages'
import {
  makeUserInterestAreasSkillsPage,
  makeUserProfilePage,
  makeUserSettingsPage,
  makeUserSpacePage,
  makeUserEnrollmentsPage,
  makeUserEnrollmentDetailPage
} from '@/main/factories/pages/user-data-factory'
import UserProfileLoader from '@/main/routes/loaders/user/user-profile-loader'
import UserSpaceLoader from '@/main/routes/loaders/user/user-space-loader'
import PathConstants from '@/main/routes/path-contants'
import { ValidAccountState } from '@presentation/contexts/auth'
import useAccount from '@presentation/hooks/auth/use-account'
import { LDClient, useLDClient } from 'launchdarkly-react-client-sdk'
import { useQueryClient } from 'react-query'
import { RouteObject } from 'react-router-dom'
import FeatureFlagLoader from '../loaders/feature-flag-loader'
import UserInterestAreasSkillsLoader from '../loaders/user/user-interest-areas-skills-loader'
import UserEnrollmentDetailLoader from './user-enrollment-detail-loader'
import UserEnrollmentsLoader from './user-enrollments-loader'
import LoggedLayout from '@/presentation/components/ui/layout/logged-layout'

const {
  USER_PROFILE,
  USER_INSTEREST_AREAS_SKILLS,
  USER_SETTINGS,
  USER_SPACE,
  USER_ENROLLMENTS_V2,
  USER_ENROLLMENT_DETAIL,
  FAVORITES
} = PathConstants.Routes

export default function BuildUserDataRoutes(): RouteObject[] {
  const [account] = useAccount() as ValidAccountState
  const queryClient = useQueryClient()
  const ldClient = useLDClient() as LDClient
  const { HOME } = PathConstants.Routes

  return [
    {
      element: <LoggedLayout navMenu="main" footerVariant="compact" enableSearch={true} />,
      children: [
        {
          path: USER_PROFILE.value,
          element: makeUserProfilePage(),
          loader: new UserProfileLoader(queryClient, ldClient, account).loader
        },
        {
          path: USER_INSTEREST_AREAS_SKILLS.value,
          element: makeUserInterestAreasSkillsPage(),
          loader: new UserInterestAreasSkillsLoader(account, ldClient, queryClient).loader
        },
        {
          path: '/user/security-privacy', // [TODO] Remove one day - backwards compatibility
          element: makeUserSettingsPage(),
          loader: new FeatureFlagLoader(
            account,
            HOME.value,
            FeatureFlag.Key.COMPANIES_ON_USER_SETTINGS,
            ldClient
          ).loader
        },
        {
          path: USER_SETTINGS.value,
          element: makeUserSettingsPage(),
          loader: new FeatureFlagLoader(
            account,
            HOME.value,
            FeatureFlag.Key.COMPANIES_ON_USER_SETTINGS,
            ldClient
          ).loader
        },
        {
          path: USER_SPACE.value,
          element: makeUserSpacePage(),
          loader: new UserSpaceLoader(queryClient, ldClient, account).loader
        },
        {
          path: USER_ENROLLMENTS_V2.value,
          element: makeUserEnrollmentsPage(),
          loader: new UserEnrollmentsLoader(queryClient, ldClient, account).loader
        },
        {
          path: USER_ENROLLMENT_DETAIL.value,
          element: makeUserEnrollmentDetailPage(),
          loader: new UserEnrollmentDetailLoader(queryClient, ldClient, account).loader
        },
        {
          path: FAVORITES.value,
          id: FAVORITES.name,
          element: makeFavoritesPage()
        }
      ]
    }
  ]
}
